import { render } from "./TermsofServiceInfo2.vue?vue&type=template&id=5c6fb89a"
const script = {}

import exportComponent from "/codebuild/output/src3191932516/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/scan/salesnote/TermsofServiceInfo2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5c6fb89a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5c6fb89a', __exports__)) {
    console.log('reload')
    api.reload('5c6fb89a', __exports__)
  }
  
  module.hot.accept("./TermsofServiceInfo2.vue?vue&type=template&id=5c6fb89a", () => {
    console.log('re-render')
    api.rerender('5c6fb89a', render)
  })

}


export default __exports__